@if (isLoading()) {
  <div class="spinner-container">
    <mat-spinner class="absolute-centered" mode="indeterminate" [diameter]="150"></mat-spinner>
  </div>
}
@if (!isLoading() && newsArticle(); as newsArticle) {
  <div class="article-container">
    <h2 class="subject">{{ newsArticle.subject }}</h2>
    <h6 class="date">{{ getDateString(newsArticle.createdDateTime) }}</h6>
    @if (newsArticle.content) {
      <div class="rich-text" [innerHtml]="newsArticle.content | parseHtml"></div>
    }
    @if (keywords().length > 0) {
      <div class="keywords-container">
        <p class="label">Keywords:</p>
        @for (keyword of keywords(); track keyword) {
          <div class="keyword-item">{{ keyword }}</div>
        }
      </div>
    }
    @if (newsArticle.fieldExperts.length > 0) {
      <div class="authors-container">
        <p class="label">Authors:</p>
        <div class="flex">
          @for (author of newsArticle.fieldExperts; track author.id) {
            <div class="author-item">
              <img
                [src]="
                  author.pictureId ? environment.bffUrl + '/file-management/files/' + author.pictureId + '/image' : '/assets/avatar.png'
                "
                alt=""
                loading="lazy"
              />
              <div>
                <p class="author-name">{{ author.firstName }} {{ author.lastName }}</p>
                <small>{{ author.jobTitle }}</small>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
